export default function Offers() {
  return (
    <section id="offers" className="py-24 bg-[#F6C1A1]/20">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-serif text-[#0F0F0F] mb-4">
            Offers for You
          </h2>
          <div className="w-24 h-1 bg-[#F2A35E] mx-auto rounded-full"></div>
        </div>

        <div className="grid md:grid-cols-1 gap-8 items-start justify-items-center">
          <div className="bg-gradient-to-br from-[#9B5E6B] to-[#F2A35E] rounded-3xl p-8 shadow-2xl relative max-w-md w-full">
            <ul className="space-y-4">
              <li className="flex items-start">
                <i className="ri-check-line text-white text-xl mr-3 flex-shrink-0"></i>
                <span className="text-white text-sm">Customized schedules</span>
              </li>
              <li className="flex items-start">
                <i className="ri-check-line text-white text-xl mr-3 flex-shrink-0"></i>
                <span className="text-white text-sm">Economic growth guaranteed</span>
              </li>
              <li className="flex items-start">
                <i className="ri-check-line text-white text-xl mr-3 flex-shrink-0"></i>
                <span className="text-white text-sm">Financial training</span>
              </li>
              <li className="flex items-start">
                <i className="ri-check-line text-white text-xl mr-3 flex-shrink-0"></i>
                <span className="text-white text-sm">Priority support (24/7)</span>
              </li>
              <li className="flex items-start">
                <i className="ri-check-line text-white text-xl mr-3 flex-shrink-0"></i>
                <span className="text-white text-sm">Monthly psychological support</span>
              </li>
              <li className="flex items-start">
                <i className="ri-check-line text-white text-xl mr-3 flex-shrink-0"></i>
                <span className="text-white text-sm">Weekly progress meetings</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
